import { render, staticRenderFns } from "./DocumentPOSTotalItemsPrint.vue?vue&type=template&id=7d183df8&scoped=true"
import script from "./DocumentPOSTotalItemsPrint.vue?vue&type=script&lang=js"
export * from "./DocumentPOSTotalItemsPrint.vue?vue&type=script&lang=js"
import style0 from "./DocumentPOSTotalItemsPrint.vue?vue&type=style&index=0&id=7d183df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d183df8",
  null
  
)

export default component.exports